module.exports = __webpack_public_path__ + "img/certificado_dgert.b336c91e.svg";